// extracted by mini-css-extract-plugin
export default {"form":"SoundMenu_form__Jnl9K","soundMenu":"SoundMenu_soundMenu__QClHj"};